const appData = {
  googleApiKey: "AIzaSyBjnsedFLB4nVkgtsi5nl3fMcCHxLcDMVI",
  dashBoardLogoName: "SMART LOGISTICS",
};
export default appData;
